import { Button } from './ui/button';
import { Cake, ExternalLink } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from './ui/dialog';

const WHATSAPP_URL = 'https://chat.whatsapp.com/C5dpCq1UAOA1ay91edZdwU';

const getRoleLabel = (role) => {
  if (role === 'head_coach') return 'Head Coach';
  if (role === 'coach') return 'Coach';
  return 'Athlete';
};

export default function BirthdayPopup({ open, onDismiss, birthdayPeople }) {
  if (!birthdayPeople || birthdayPeople.length === 0) return null;

  return (
    <Dialog open={open} onOpenChange={onDismiss}>
      <DialogContent className="bg-[#18181B] border-[#27272A] max-w-md" data-testid="birthday-popup">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <div className="bg-[#CCFF00]/10 p-5 rounded-full">
              <Cake className="w-12 h-12 text-[#CCFF00]" />
            </div>
          </div>
          <DialogTitle className="text-3xl font-heading font-black uppercase text-[#FAFAFA] text-center">
            Happy Birthday!
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          {birthdayPeople.map((person) => (
            <div key={person.id} className="bg-[#09090B] border border-[#CCFF00]/20 rounded-sm p-4 text-center">
              <p className="text-xs text-[#CCFF00] uppercase tracking-wide font-semibold mb-1">
                {getRoleLabel(person.role)}
              </p>
              <p className="text-2xl font-heading font-black uppercase text-[#FAFAFA]">
                {person.name}
              </p>
              <p className="text-sm text-[#A1A1AA] mt-2">
                Wishing you an amazing day filled with strength and joy!
              </p>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 mt-6">
          <Button
            onClick={() => window.open(WHATSAPP_URL, '_blank')}
            data-testid="birthday-whatsapp"
            className="w-full bg-[#25D366] text-white font-bold uppercase tracking-wider hover:bg-[#1da851] rounded-sm flex items-center justify-center gap-2"
          >
            <ExternalLink className="w-4 h-4" />
            Wish Happy Birthday
          </Button>
          <Button
            onClick={onDismiss}
            data-testid="birthday-dismiss"
            variant="outline"
            className="w-full border-[#27272A] text-[#A1A1AA] hover:bg-[#27272A] hover:text-[#FAFAFA] uppercase tracking-wider rounded-sm"
          >
            Got It
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
